
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.94 30.53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Laag_2","data-name":"Laag 2"}},[_c('g',{attrs:{"id":"Laag_1-2","data-name":"Laag 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M17 12.35a5.58 5.58 0 015.37 5.76A5.58 5.58 0 0117 23.86a5.57 5.57 0 01-5.37-5.75A5.57 5.57 0 0117 12.35m7.81-8.8l-.34-1.84A2 2 0 0022.52 0h-11.1a2 2 0 00-1.95 1.71l-.17.92c-.1.51 2.51.92 5.83.92z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M17 26a7.64 7.64 0 01-7.36-7.88 7.65 7.65 0 017.36-7.9 7.65 7.65 0 017.36 7.89A7.64 7.64 0 0117 26M8.48 12.35H5.3a1.07 1.07 0 010-2.13h3.18a1.07 1.07 0 010 2.13M31 5.68H3a3.1 3.1 0 00-3 3.2v18.46a3.1 3.1 0 003 3.19h28a3.1 3.1 0 003-3.19V8.88a3.1 3.1 0 00-3-3.2"}})])])])
          )
        }
      }
    